export default __webpack_public_path__ + "static/media/signup.7498237e.png";